import React from 'react';

const iCaretUp = () => {
  return (
    <svg
      width="13"
      height="8"
      className="tutorium-icon"
      viewBox="0 0 13 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.54"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4833 8L13 6.48649L6.5 -2.84124e-07L6.70141e-07 6.48649L1.51667 8L6.5 3.02703L11.4833 8Z"
      />
    </svg>
  );
};

const iCaretDown = () => {
  return (
    <svg
      width="14"
      height="8"
      className="tutorium-icon"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.54"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.01667 -1.01997e-06L0.5 1.51351L7 8L13.5 1.51351L11.9833 -1.45563e-06L7 4.97297L2.01667 -1.01997e-06Z"
      />
    </svg>
  );
};

export default {
  CaretDown: iCaretDown,
  CaretUp: iCaretUp,
};
